import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'license';

const licenseService = {
  getItems: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    });
  },

  updateItem: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },
};
export default licenseService;
